<template>
    <div class="listingvatAccountCode">
        <preloader :display="loading" class="preloader prelative" />
        <PopupAccountCodeEdit
            v-if="shouldDisplayPopupEditAccountCode"
            ref="popupAccountCodeEdit"
            :accountsCodes="accountsCodes"
            :tax="taxToEdit"
            @close="onClosePopupAccountCodeEdit"
            :defaultCode="defaultCode"
            @updateSuccessful="updateTaxSuccessful"
        />
        <h1 class="typographies-heading-h1">{{ $l10n.__('Codes comptables TVA') }}</h1>
        <CustomTable>
            <template slot="header">
                <th class="singleLineHeader listingvatAccountCode__table-label">
                    <div class="typographies-paragraph-medium-bold">{{ $l10n.__('Label') }}</div>
                </th>
                <th class="singleLineHeader listingvatAccountCode__table-tva">
                    <div class="typographies-paragraph-medium-bold">{{ $l10n.__('TVA') }}</div>
                </th>
                <th class="doubleLineHeader listingvatAccountCode__table-code">
                    <div class="typographies-paragraph-medium-bold">
                        {{ $l10n.__('Codes comptables Vente\n(débits)') }}
                    </div>
                </th>
                <th class="doubleLineHeader listingvatAccountCode__table-code">
                    <div class="typographies-paragraph-medium-bold">
                        {{ $l10n.__('Codes comptables Vente\n(encaissements)') }}
                    </div>
                </th>
                <th class="doubleLineHeader listingvatAccountCode__table-code">
                    <div class="typographies-paragraph-medium-bold">
                        {{ $l10n.__('Codes comptables Achats\n(débits)') }}
                    </div>
                </th>
                <th class="doubleLineHeader listingvatAccountCode__table-code">
                    <div class="typographies-paragraph-medium-bold">
                        {{ $l10n.__('Codes comptables Achats\n(encaissements)') }}
                    </div>
                </th>
                <th></th>
            </template>
            <template slot="content">
                <tr v-for="tax of vatList" :key="tax.id">
                    <td class="pl-3">
                        <div class="typographies-paragraph-medium-regular">
                            {{ $l10n.__(tax.label) }}
                        </div>
                    </td>
                    <td class="pl-3">
                        <div class="typographies-paragraph-medium-regular">
                            {{ tax.rate | numberformat }} %
                        </div>
                    </td>
                    <td class="pl-3">
                        <div class="typographies-paragraph-medium-regular">
                            {{ tax.debit_vat.collected_vat.code }}
                        </div>
                    </td>
                    <td class="pl-3">
                        <div class="typographies-paragraph-medium-regular">
                            {{ tax.collection_vat.collected_vat.code }}
                        </div>
                    </td>
                    <td class="pl-3">
                        <div class="typographies-paragraph-medium-regular">
                            {{ tax.debit_vat.deductible_vat.code }}
                        </div>
                    </td>
                    <td class="pl-3">
                        <div class="typographies-paragraph-medium-regular">
                            {{ tax.collection_vat.deductible_vat.code }}
                        </div>
                    </td>
                    <td class="colActionIcon">
                        <CompassIconButton
                            ref="editIcon"
                            icon="edit"
                            size="small"
                            @click="selectTax(tax)"
                        />
                    </td>
                </tr>
            </template>
        </CustomTable>
    </div>
</template>

<script>
import CustomTable from 'vcomponents/utilities/CustomTable.vue';
import PopupAccountCodeEdit from 'vcomponents/accounting/PopupAccountCodeEdit.vue';
import AccountingService from 'api/accountingService';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('corp');

export default {
    components: {
        PopupAccountCodeEdit,
        Preloader,
        CustomTable,
    },
    data() {
        return {
            shouldDisplayPopupEditAccountCode: false,
            taxToEdit: null,
            vatList: [],
            accountsCodes: [],
            loading: true,
        };
    },
    events: {
        'accounting:click-edit-account-code': 'selectTax',
    },
    async created() {
        this.vatList = await AccountingService.getTaxesWithAccountingCodes({
            limit: 100,
            order: 'rank',
        });
        AccountingService.getListAccountingCodes().then((response) => {
            // We filter accounting code list to return only code starting with 445 or 22 which are vat account code
            this.accountsCodes = response.filter((item) =>
                item.code.startsWith(this.setupLang === 'fr' ? '445' : '22'),
            );
            this.loading = false;
        });
    },
    computed: {
        ...mapState({
            setupLang: 'setupLang',
        }),
        defaultCode() {
            return this.accountsCodes?.find((codes) => codes.code.match(/^445800$/));
        },
    },
    methods: {
        onClosePopupAccountCodeEdit() {
            this.shouldDisplayPopupEditAccountCode = false;
            this.taxToEdit = null;
        },
        updateTaxSuccessful(tax) {
            Push.success(this.$l10n.__('La taxe a bien été bien mise à jour'));
            this.vatList = this.vatList.map((item) => {
                return item.id === tax.id ? tax : item;
            });
            this.shouldDisplayPopupEditAccountCode = false;
            this.taxToEdit = null;
        },
        selectTax(tax) {
            this.taxToEdit = tax;
            this.shouldDisplayPopupEditAccountCode = true;
        },
    },
};
</script>
<style lang="scss">
.listingvatAccountCode {
    h1 {
        margin: 0 0 var(--spacing-5);
    }
    table {
        width: 100%;
        thead {
            th {
                padding-left: 16px;
                white-space: pre-line;
            }

            .doubleLineHeader {
                padding-bottom: 7px;
                padding-top: 7px;
            }

            .singleLineHeader {
                padding-bottom: 14px;
                padding-top: 14px;
            }
        }

        .colActionIcon {
            padding: 8px 16px;
        }
        .listingvatAccountCode__table-label {
            min-width: 333px;
            width: 20%;
        }
        .listingvatAccountCode__table-tva {
            min-width: 94px;
        }
        .listingvatAccountCode__table-code {
            min-width: 213px;
            width: 20%;
        }
    }
}
</style>
